import { useTranslation } from "react-i18next";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { AppButton } from "@/shared/Components";
import { useModal } from "@/features/modals/lib";
import { ModalVcfInfo } from "@/features/modals";

export const VcfInfoButton = () => {
  const { t } = useTranslation();
  const { hideModal, isModalOpen, showModal } = useModal();

  return (
    <>
      <AppButton
        onClick={showModal}
        icon={<QuestionCircleOutlined />}
        iconPosition="start"
        type="link"
      >
        {t("vcfModal.modalTitle")}
      </AppButton>
      <ModalVcfInfo open={isModalOpen} onCancel={hideModal} onOk={hideModal} />
    </>
  );
};
